import moment from "moment";
import React, { useState } from "react";

export default function AgendaModal({ isOpen, onClose, meetings }) {
  // meetings: { "2025-11-01": [{ inicio:"08:00", fim:"09:00" }, ... ] }

  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDay, setSelectedDay] = useState(null);

  if (!isOpen) return null;

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const daysInMonth = lastDay.getDate();

  const prevMonth = () => {
    setSelectedDay(null);
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const nextMonth = () => {
    setSelectedDay(null);
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const formatDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

  const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);

  let month_oficial=month+1;
            if(month_oficial==13){
                month_oficial=1;
            }

  const selectedMeetings = selectedDay ? meetings.filter((item)=>{
    let day=selectedDay.getDate().toString();
    if(day.length==1){
        day='0'+day;
    }
    console.log(moment(item.date).format('YYYY-MM-DD'),year+'-'+month_oficial+'-'+day)
                return moment(item.date).format('YYYY-MM-DD')==year+'-'+month_oficial+'-'+day;
            }) || [] : [];

            console.log(selectedMeetings)

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4" style={{zIndex:1000}}>
      <div className="bg-white  rounded-2xl shadow-xl p-6" style={{minWidth:'70%'}}>
        <div className="flex justify-between items-center mb-4">
          <button onClick={prevMonth} className="px-3 py-1 bg-gray-200 rounded-lg">◀</button>
          <h2 className="text-xl font-semibold">
            {currentDate.toLocaleString("default", { month: "long" })} {year}
          </h2>
          <button onClick={nextMonth} className="px-3 py-1 bg-gray-200 rounded-lg">▶</button>
        </div>

        <div className="grid grid-cols-7 gap-2 text-center mb-4">
          {["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"].map((d) => (
            <div key={d} className="font-medium text-gray-600">{d}</div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-2">
          {Array(firstDay.getDay())
            .fill(null)
            .map((_, idx) => (
              <div key={"e" + idx}></div>
            ))}

          {daysArray.map((day) => {
            const dateObj = new Date(year, month, day);
            const dateStr = formatDate(dateObj);
            let month_oficial=month+1;
            if(month_oficial==13){
                month_oficial=1;
            }
            const hasMeetings = meetings.filter((item)=>{
                let day2= day.toString().length==1?('0'+day):day
                return moment(item.date).format('YYYY-MM-DD')==year+'-'+month_oficial+'-'+day2;
            }).length
            const isSelected = selectedDay && dateObj.toDateString() === selectedDay.toDateString();

            return (
              <button
                key={day}
                onClick={() => setSelectedDay(dateObj)}
                className={`p-2 rounded-lg transition
                  ${isSelected ? "bg-blue-700 text-white" : hasMeetings ? "bg-blue-200" : "bg-gray-100"}
                `}
              >
                {day}
              </button>
            );
          })}
        </div>

        <div style={{marginTop:15,marginBottom:15}}>
          <div className="flex align-center">
          <div style={{width:25,height:25,marginRight:10}} className="bg-blue-200">
            
          </div>
          <span>Dia com agenda</span>
          </div>
          <div className="flex align-center" style={{marginTop:5}}>

          <div style={{width:25,height:25,marginRight:10}} className="bg-blue-700">
            
          </div>
          <span>Dia selecionado</span>
          </div>
          <div className="flex align-center" style={{marginTop:5}}>

          <div style={{width:25,height:25,marginRight:10,border:'1px solid grey'}} className="bg-white-400">
            
          </div>
          <span>Dia sem agenda</span>
          </div>

        </div>

        <div className="mt-6">
          <h3 className="text-lg font-semibold mb-2">Reuniões do dia</h3>

          {selectedMeetings.length === 0 ? (
            <p className="text-gray-500">Nenhuma reunião marcada.</p>
          ) : (
            <ul className="space-y-2">
              {selectedMeetings.map((m, idx) => (
                <li key={idx} className="p-3 bg-gray-100 rounded-lg">
                  <p><b>Agenda: </b>{m?.appointment?.name}</p>
                  <p><b>Produto/Fase/Atividade: </b>{m?.appointment?.product?.name} {'->'} {m?.appointment?.product?.phases?.filter((item)=>item._id==m?.appointment?.phase)[0]?.name} {'->'} {m?.appointment?.product?.phases?.filter((item)=>item._id==m?.appointment?.phase)[0]?.activities?.filter((item)=>item._id==m?.appointment?.activity)[0]?.name}</p>

                  <p><b>Agendado por: </b>{m?.user?.name}</p>
                  <p><b>Partners envolvidos: </b>{m?.collaborators?.map((item)=>item.name).join(', ')}</p>
                  <p><b>Cliente: </b>{m?.client?.name}</p>
                  <p><b>Horário: </b>{moment(m.date).format('HH:mm')} - {moment(m.date_end).format('HH:mm')}</p>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="mt-6 text-right">
          <button onClick={onClose} className="px-4 py-2 bg-red-500 text-white rounded-lg">Fechar</button>
        </div>
      </div>
    </div>
  );
}
